import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';

const useCardTemplateIdsInPalette = (paletteId: string) : string[] => {
  const userId = useCurrentUserId();
  const ructDb = useSelector((state: RootState) => state.relationUserCardTemplateDb);
  const rpctDb = useSelector((state: RootState) => state.relationPaletteCardTemplateDb);

  const ructIds = Object.keys(ructDb.relationUserCardTemplates).filter(id => ructDb.relationUserCardTemplates[id].userId === userId);
  const idsByRuctIds = ructIds.map(id => ructDb.relationUserCardTemplates[id].cardTemplateId);

  const rpctIds = Object.keys(rpctDb.relationPaletteCardTemplates).filter(id => rpctDb.relationPaletteCardTemplates[id].paletteId === paletteId);
  // make the array ascending by order
  rpctIds.sort((a, b) => rpctDb.relationPaletteCardTemplates[a].order - rpctDb.relationPaletteCardTemplates[b].order);
  const idsByRpctIds = rpctIds.map(id => rpctDb.relationPaletteCardTemplates[id].cardTemplateId);

  const ids = idsByRpctIds.filter(id => idsByRuctIds.includes(id));

  return ids;
}

export default useCardTemplateIdsInPalette;
